export default "__VITE_ASSET__f03e1ba8__"